import img1 from '../images/amari/AmrWa.webp';
import img2 from '../images/amari/amari-watergate-14b.webp';

export const amariImages = [img1, img2];
